import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useCustomHook from './hooks';
import { Button, Grid, Box } from '@mui/material';
import { PageContainer, TableComponents, ButtonLoading, SimpleDialog, Icons, FilterPod } from 'components';
import { columns, generateData } from './components/Columns';
import Services from '../Services';
import { useStyles } from './style';
import createToast from 'components/Toast/Toast';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import FilterButton from 'components/FilterPod/FilterButton';
import InitFilters from './components/InitFiltering';
import { legalUser, naturalUser, customFilter } from './components/InitFiltering';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { FILTER_TYPES } from 'components/FilterPod';
import axios from 'axios';

export default function ACLList() {
  const { loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    page,
    setPage,
    loadingBtn,
    setLoadingBtn,
    removeDialog,
    setRemoveDialog,
    selectedRow,
    setSelectedRow,

    filters, setFilters,
    isLoadingFilter, setIsLoadingFilter,
    copyOriginalFilter, setCopyOriginalFilter,
    copyTempFilter, setCopyTempFilter,
    openFilterDialog, setOpenFilterDialog,
    setCopyOpenDgFilter,
    isLoadingCheckSuperAdmin, setIsLoadingCheckSuperAdmin,
    superAdminObject, setSuperAdminObject,
  } = useCustomHook();
  let tableRef = useRef();
  //--HOOKS--//
  const classes = useStyles();

  const navigate = useNavigate();
  const actionsList =
    getDynamicObjectAction([
      'updateACLBtn',
      'deleteACLBtn',
      'addACLUsersBtn',
      'craeteACLBtn'


    ])


  const handleCloseFilterDialog = () => {
    setOpenFilterDialog(false);
    setFilters([...JSON.parse(copyOriginalFilter)])
    setCopyOriginalFilter(null);
    setCopyTempFilter(null)

  }

  const checkSuperAdmin = () => {
    Services.checkAdmin().then(res => {
      setSuperAdminObject({ getData: true, isAdmin: res?.result?.isAdmin || false })
      setFilters(InitFilters(res?.result?.isAdmin))
      setIsLoadingCheckSuperAdmin(false)

    }).catch(err => {
      setIsLoadingCheckSuperAdmin(false)
    })
  }

  useEffect(() => {
    checkSuperAdmin();
  }, [])


  useEffect(() => {
    if (openFilterDialog === true) {
      setCopyOriginalFilter(JSON.stringify(filters))
    } else {
      setCopyOriginalFilter(null);
      setCopyTempFilter(null)
    }

  }, [openFilterDialog])
  //--API REQUESTS--//
  const getList = async (query) => {
    try {
      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);
      setLoading(true);

      let params = {
        isLegal: queries['userType'] ? (queries['userType'] === '1' ? true : false) : null,
        memberType: queries['userTypeList'] ? queries['userTypeList'] : null,
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query?.pageSize || size,
        member: queries['inputType'] ||
          queries['username'] ||
          queries['email'] ||
          queries['id'] ||
          queries['phone_number'] ||
          queries['nationalcode'] || null
      };

      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });
      const res = await Services.getAclList(params);
      let list = [];

      list = generateData(res?.result?.groups, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });

      setLoading(false);
      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d;
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };

      }
    }
  };
  const ChangeStateActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtn}
          name="بله"
          onClick={removeMember}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };
  const removeMember = () => {
    setLoadingBtn(true);
    Services.deleteAclGroup(selectedRow?.path)
      .then((res) => {
        createToast('موفق', 'عملیات با موفقیت انجام شد', 'success');
        setTimeout(() => {
          tableRef?.current?.onChangeTable();
        }, 100);
        setTimeout(() => {
          handleCloseDialog();

          setLoadingBtn(false);
        }, 150);
      })
      .catch((error) => {
        setLoadingBtn(false);
      });
  };
  const handleCloseDialog = () => {
    setRemoveDialog({ title: '', content: '', open: false });
  };

  const clearAllFilters = (tempFilters, key) => {
    if (key === 'clear') {
      setFilters(InitFilters(superAdminObject.isAdmin))
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable(true);
      }, 100)
    }
  }
  const onFiltersChange = (newFilters) => {
    let data = newFilters

    setCopyOriginalFilter(null);
    setCopyTempFilter(null)
    if (!newFilters[0]?.value) {
      setFilters(InitFilters(superAdminObject.isAdmin))
      setCopyOpenDgFilter(null);
    } else {
      setFilters([...newFilters])
    }

    //================چک میکند اگر فیلتر سومی رو چیزی وارد نکرده باشد به کاربر خطا نمایش میدهد و سرویس کال نمیشود
    const filter = toFilterVOS([...newFilters]);
    if (filter.length === 2) {
      createToast('خطا', `لطفا فیلد ${newFilters[2]?.title} را وارد نمایید.`, 'danger');
      return
    }
    //=======================

    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };
  const setValueToFilter = (obj, isShowLoading = false) => {
    if (Array.from(obj)[2]?.keyName === 'inputType' || Array.from(obj)[2]?.keyName === 'username') {
      setFilters(prev => [obj[0], obj[1], customFilter.id])
    }
    setTimeout(() => {
      setFilters(prev => obj)
    }, 1);
    setCopyTempFilter(JSON.stringify(obj))

  }

  const onChangeFilterItem = async (tempFilters) => {
    let inputType = {
      title: 'نام کاربری',
      label: 'نام کاربری',
      keyName: 'inputType',
      id: 4,
      value: '',
      filterType: FILTER_TYPES.text,
      filterProps: { dir: 'ltr', englishNumber: true },
      disableDelete: true,
    };

    let typeSeletct = {
      '1': legalUser,
      '2': naturalUser
    }

    if (!tempFilters || tempFilters.length === 0 || !openFilterDialog) { // خالی برگرده
      return
    }
    if (JSON.parse(copyOriginalFilter)[0]?.value !== tempFilters[0]?.value) { // اگر حقیقی یا حقوقی تغییر کرده باشد

      if (!copyTempFilter || JSON.parse(copyTempFilter)[0]?.value !== tempFilters[0]?.value) { // کپی خالی باشه یا کپی حقیقی و حقوقی تغییر کرده باشه
        let obj = [tempFilters[0], ...typeSeletct[tempFilters[0]?.value], JSON.parse(JSON.stringify(inputType))];
        setValueToFilter(obj, true)
      } else if (JSON.parse(copyTempFilter)[0]?.value === tempFilters[0]?.value &&
        JSON.parse(copyTempFilter)[1]?.value !== tempFilters[1]?.value) { // 
        let obj = [tempFilters[0], tempFilters[1], customFilter[tempFilters[1]?.value]];
        setValueToFilter(obj, true)
      }
    } else { // اگه حقیقی و حقوقی بدون تغییر باشه
      if (!copyTempFilter &&
        (JSON.parse(copyOriginalFilter)[0]?.value !== tempFilters[0]?.value ||
          JSON.parse(copyOriginalFilter)[1]?.value !== tempFilters[1]?.value)) { // دیالوگ فیلتر بار دوم باز شده و تغییرات روی فیلتر میخواد انجام بده -کمبوباکس اول و دوم باید تغییر کرده باشد 
        let obj = [tempFilters[0], tempFilters[1], customFilter[tempFilters[1]?.value]];
        setValueToFilter(obj)
        return;
      }
      if (filters[0]?.value !== tempFilters[0]?.value) { // فیلتر فعلی رو با فیلتر برگشتی مقایسه میکنه
        let obj = [tempFilters[0], ...typeSeletct[tempFilters[0]?.value], JSON.parse(JSON.stringify(inputType))];
        setValueToFilter(obj)
        return;
      }
      if (copyTempFilter && JSON.parse(copyTempFilter)[0]?.value !== tempFilters[0]?.value) { // مقدار کپی اولی و مقدار برگشت تغییر کرده باشه
        let obj = [tempFilters[0], tempFilters[1], customFilter[tempFilters[1]?.value]];
        setValueToFilter(obj)
      } else if (copyTempFilter && JSON.parse(copyTempFilter)[0]?.value === tempFilters[0]?.value &&
        JSON.parse(copyTempFilter)[1]?.value !== tempFilters[1]?.value) { // مقدا اولی و کپی برابره ولی مقدار کمبوباکس دومی تغییر کرده
        let obj = [tempFilters[0], tempFilters[1], customFilter[tempFilters[1]?.value]];
        setValueToFilter(obj)
      }
    }


  }

  const hint = 'در این بخش  میتوانید  مدیریت دسترسی‌ ها را مشاهده کنید.';

  return (
    <>
      <PageContainer
        title="مدیریت دسترسی ها"
        description={hint}
        breadcrumbs={constBreadCrumbsTitle.ACL_LIST}
        className={classes.root}
        loading={isLoadingCheckSuperAdmin}
      >
        <Grid item className={classes.actionButton} style={{ position: 'relative' }}>

          <Grid item xs={12} className={classes.filterbtn}>
            <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                onChangeFilterItem={onChangeFilterItem}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
                isLoading={isLoadingFilter}
                isShowCustomRemoveBtn={true}
                clearAllFilters={clearAllFilters}
              />
            </Box>
          </Grid>

          <Grid className={classes.addUserBtn}>
            {actionsList['craeteACLBtn'] && (
              <Button
                className={classes.cardHeaderButton}
                onClick={() => navigate('/Acl/AddGroup')}
                color="primary"
                startIcon={<Icons icon='plusCircle' color='#fff' size='18' />}
                variant="contained"
              >
                ایجاد دسترسی
              </Button>
            )}
          </Grid>

        </Grid>
        <TableComponents
          data={getList}
          columns={columns(actionsList, navigate, setSelectedRow, setRemoveDialog)}
          isLoading={loading}
          ref={tableRef}
          onChange={(ps) => {
            setPage(ps?.pageNumber)
            setSize(ps?.pageSize)
            return getList(ps)
          }}
        />
        <SimpleDialog
          title={removeDialog?.title}
          content={removeDialog?.content}
          open={removeDialog?.open || false}
          actions={<ChangeStateActionBtn />}
        />

      </PageContainer>
    </>
  );
}
